import { render } from "./ManagerRetributionConfiguration.vue?vue&type=template&id=6f997eae"
import script from "./ManagerRetributionConfiguration.vue?vue&type=script&lang=js"
export * from "./ManagerRetributionConfiguration.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__